(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 53276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(646);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96119);



// import SharedButton from "@components/severalbrands/sharedButton";


const HeroSection = ()=>{
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // const getTitle = () => {
    //     const fallbackStaticTitle =
    //         "Expand Your Client Base with <span style={{ whiteSpace: 'nowrap' }}>High-Intent</span> MVA Leads";
    //     if (!genericPage) {
    //         return fallbackStaticTitle;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-title",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : formattedTitle
    //             ? formattedTitle
    //             : fallbackStaticTitle;
    //     }
    // };
    // const getDescription = () => {
    //     const fallbackStaticDescription =
    //         "Discover how our tailored car accident lead generation solutions can transform your case intake. Get a consultation by completing the form below!";
    //     if (!genericPage) {
    //         return fallbackStaticDescription;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-description",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : fallbackStaticDescription;
    //     }
    // };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().bgStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[category?.slug]}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().innerContainerStyle),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["main-banner"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    classes: {
                        formClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().form),
                        stepTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
                        stepDescriptionClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
                        formButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
                        formFieldClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-field"]),
                        formStepInnerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["steps-inner"]),
                        stepClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-block"]),
                        fieldsClassName: {
                            radio: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"]),
                            checkbox: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkbox-field"]),
                            input: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-field"]),
                            multiSelect: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["multiSelect-field"]),
                            select: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["select-field"]),
                            textarea: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["text-area-field"])
                        },
                        fieldsWrapperClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fields-wrapper"]),
                        tcpaClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa),
                        labelAsTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-as-step-title"]),
                        formProgressbarClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["progress-background"]),
                        fieldErrorMessageClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-style"]),
                        formFieldLabelClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-label"]),
                        fieldNoteClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["note-style"])
                    },
                    backButton: {
                        class: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["back-button"]),
                        label: ""
                    },
                    colors: {
                        primaryColor: "#EF4F80"
                    },
                    showProgress: true,
                    showStepNumberOnly: true,
                    searchableMultiSelect: true
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroSection);


/***/ }),

/***/ 23554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SecondSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/severalbrands/ourStoryPage/mainSharedComponent/index.tsx
var mainSharedComponent = __webpack_require__(62652);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/components/severalbrands/legalPage/secondSection/ourApproach/style.module.scss
var style_module = __webpack_require__(18798);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/legalPage/secondSection/ourApproach/index.tsx



const ourApproachList = [
    {
        title: "Collaborative Strategy Development",
        description: "We team up with your law firm to formulate a pricing strategy that aligns with your performance goals and fulfills your specific needs."
    },
    {
        title: "Custom Campaign Creation",
        description: "By conducting in-depth research, we craft targeted campaigns that reach genuine customers injured in car accidents, optimizing for maximum conversion."
    },
    {
        title: "Advanced Lead Verification",
        description: "Utilizing a cutting-edge verification system, we sift out inaccuracies, prevent fraud, and eliminate duplicates, ensuring only the highest-quality leads are nurtured and optimized for increased conversion rates. We send high-quality leads to your reliable intake center, ensuring you receive leads that are ready to be signed up."
    },
    {
        title: "Performance Feedback Loop",
        description: "We actively seek feedback on lead effectiveness through regular performance reports, allowing us to refine our strategies and continuously enhance lead quality to connect you with your ideal clientele."
    },
    {
        title: "KPI-Driven Success",
        description: "In collaboration with our partners, we establish clear Key Performance Indicators (KPIs) to measure cost-effectiveness and optimize our campaigns based on these KPIs to continuously increase quality and conversions."
    },
    {
        title: "Ongoing Optimization",
        description: "We cyclically refine steps 2 through 4, aiming for a seamless process that consistently meets our shared KPIs and drives mutual satisfaction and success."
    }, 
];
const paragraphsStyle = "mt-2 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
function OurApproach({ title ="Our Approach" , list =ourApproachList  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${(style_module_default()).bgStyle}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:py-32 py-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.h2 */.E.h2, {
                    transition: {
                        duration: 1.5
                    },
                    initial: {
                        opacity: 0,
                        y: 150
                    },
                    whileInView: {
                        opacity: 1,
                        y: 0
                    },
                    viewport: {
                        once: true
                    },
                    className: "text-[#351C4F] font-bold 3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "lg:mt-16 mt-8 flex flex-wrap justify-center 3xl:gap-20 gap-6",
                    children: list.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.li */.E.li, {
                            transition: {
                                duration: 1.5
                            },
                            initial: {
                                opacity: 0,
                                y: 150
                            },
                            whileInView: {
                                opacity: 1,
                                y: 0
                            },
                            viewport: {
                                once: true
                            },
                            className: (style_module_default()).stepStyle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: `mt-6   lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F] font-bold`,
                                    children: el.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: `${paragraphsStyle}`,
                                    children: el.description
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/legalPage/secondSection/index.tsx



const defaultSecondSectionInfo = {
    img: "/severalbrands/assets/images/boostingClientAcquisitionImg.png",
    mainTitle: "Enhancing Client Intake for MVA Lawyers",
    paragraphs: [
        "Motor vehicle accident (MVA) lawyers often face significant challenges in client acquisition, with over 50% of law firms reporting difficulties in this area. High costs and the need to juggle multiple responsibilities, especially for solo practitioners and small firms, contribute to this struggle.",
        "At Several Brands, we specialize in generating high-quality leads for MVA lawyers through clear, educational content and targeted ads. Our approach ensures that your legal services are visible to the right audience, leading to higher conversion rates and a more efficient client intake process. By partnering with us, MVA lawyers can focus on their core practice while we handle the complexities of client acquisition, ultimately driving down costs and boosting profitability.", 
    ],
    mainSectionClassName: `3xl:gap-[200px] lg:gap-16 gap-[40px] `,
    mainTitleClassName: "text-[#351C4F]",
    imgClassName: "w-[285px]  h-[240px] md:w-[650px] md:min-w-[650px] md:h-[550px] relative 3xl:w-[750px] 3xl:min-w-[750px] 3xl:h-[650px] 3xl:mt-16  "
};
function SecondSection({ mainInfo =defaultSecondSectionInfo , approach  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "3xl:mt-52 lg:mt-28 mt-14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainSharedComponent/* default */.Z, {
                info: mainInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurApproach, {
                title: approach?.title,
                list: approach?.list
            })
        ]
    });
}


/***/ }),

/***/ 58721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ThirdSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/severalbrands/whyPartnerWithUs/index.tsx
var whyPartnerWithUs = __webpack_require__(64080);
// EXTERNAL MODULE: ./src/components/severalbrands/ourStoryPage/mainSharedComponent/index.tsx
var mainSharedComponent = __webpack_require__(62652);
;// CONCATENATED MODULE: ./src/components/severalbrands/legalPage/thirdSection/maximizeYourFirmGrowth/index.tsx


const defaultGrowthList = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Maximize Your Firm's Growth with Multifaceted Marketing Strategies",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "SEO provides sustainable growth and revenue enhancement at no extra cost but might not scale quickly. To accelerate our clients' growth, we integrate SEM tactics. This strategy includes a specialized team for SEO content development and a robust team of over 20 SEM professionals managing paid campaigns across Google, Bing, and Yahoo. This dual approach ensures our digital marketing efforts are both effective and comprehensive.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] lg:ml-16 3xl:ml-20`,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#351C4F]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Innovative Display Advertising",
        paragraphs: [
            "Our display advertising strategy employs a variety of platforms, incorporating the Google Display Network, native advertising with Taboola and Outbrain, PPV campaigns, and other external networks. With more than ten years in the field, we have honed our techniques to optimize conversion rates and deliver superior campaign performance consistently.", 
        ],
        mainSectionClassName: `lg:gap-[210px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#351C4F] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Strategic Localization:",
        paragraphs: [
            "Localization is a critical strategy for effectively reaching global markets or multilingual audiences. For instance, law firms in the US targeting both English and Spanish speakers can significantly benefit from this approach.", 
        ],
        mainSectionClassName: `3xl:gap-[210px] lg:gap-[150px]  gap-[40px]  lg:ml-16 3xl:ml-20`,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#351C4F] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function MaximizeFirmGrowth({ list =defaultGrowthList  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `lg:my-32 my-16`,
        children: list.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:mt-36 mt-14 first-of-type:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainSharedComponent/* default */.Z, {
                    info: el
                })
            }, index))
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/legalPage/thirdSection/index.tsx



const defaultPartnerData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with clients needing your legal expertise, navigating the complexities of the legal market with confidence.`,
            className: "default"
        },
        {
            text: `Let us help you unlock your firm's full potential and thrive in this competitive industry. Together, we can transform your marketing strategy into a powerful tool for success, ensuring that your legal solutions reach the clients who need them most.`,
            className: "default"
        }, 
    ],
    buttonText: "Partner With Us"
};
function ThirdSection({ growthList , partnerData  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaximizeFirmGrowth, {
                list: growthList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-32 lg:mt-56 lg:mb-48 mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whyPartnerWithUs/* default */.Z, {
                    partnerWitUSData: partnerData ?? defaultPartnerData
                })
            })
        ]
    });
}


/***/ }),

/***/ 62652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainSharedComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76265);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41681);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function MainSharedComponent({ info , domainInfo  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.section */ .E.section, {
        transition: {
            duration: 1.5
        },
        initial: {
            opacity: 0,
            y: 150
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true
        },
        className: `flex flex-col lg:flex-row  ${info.mainSectionClassName ? info.mainSectionClassName : ""} `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: ` ${info.img ? "3xl:max-w-[800px] max-w-[500px]" : ""} mx-auto lg:mx-0 ${info.imgToLeft ? "order-2 lg:order-2" : "order-2 lg:order-1"} ${info.secondSectionClassName ? info.secondSectionClassName : ""}`,
                children: [
                    info.mainH1Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: `font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${info.mainTitleClassName ? info.mainTitleClassName : ""} `,
                        children: info.mainTitle
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: `font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${info.mainTitleClassName ? info.mainTitleClassName : ""} `,
                        children: info.mainTitle
                    }),
                    info.secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: `3xl:text-4xl lg:text-2xl text-lg font-bold ${info.secondTitleClassName ? info.secondTitleClassName : ""}`,
                        children: info.secondTitle
                    }),
                    info.paragraphs?.map((pInfo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `3xl:mt-6 lg:mt-4 mt-3 3xl:text-3xl 3xl:leading-[3rem] lg:text-xl  text-base lg:leading-8 font-light ${info.textClassName ? info.textClassName : ""}`,
                            children: pInfo
                        }, index)),
                    info.showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-9",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            pdf: true,
                            href: "https://cdn.severalbrands.com/attachments/2025/02/severalbrands_resources.pdf",
                            children: "Download Your Free PDF"
                        })
                    }),
                    info.showLogos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: `flex 3xl:mt-10 mt-5 justify-center gap-10 flex-wrap`,
                        children: domainInfo?.config?.sliderLogos?.default?.map((logo)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: `w-[100px] h-[22px]  3xl:w-[150px] 3xl:h-[34px] relative ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imgStyle)}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: logo.path,
                                    alt: logo.slug,
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            }, logo.slug))
                    })
                ]
            }),
            info.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${info.imgClassName ? info.imgClassName : ""}   mx-auto lg:mx-0  ${info.imgToLeft ? "order-1 lg:order-1" : "order-1 lg:order-2"}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: info.img,
                    alt: "img",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}


/***/ }),

/***/ 81467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57772);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children , href , pdf , regularButton =false , onCLick , scrollButton =false  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const buttonClassName = `  text-white  py-3 sm:px-16 px-7 sm:text-lg 3xl:text-2xl font-bold rounded-lg cursor-pointer block w-fit ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btnStyle)}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: regularButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: scrollButton ? scrollToTop : onCLick,
            className: buttonClassName,
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: pdf ? "_blank" : "_self",
            rel: "noreferrer",
            className: buttonClassName,
            children: children
        })
    });
}


/***/ }),

/***/ 64080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyPartnerWithUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76265);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12658);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);





function WhyPartnerWithUs({ partnerWitUSData  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bgStyle),
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: `font-bold 3xl:text-6xl lg:text-5xl text-3xl lg:leading-[54px] leading-9 ${partnerWitUSData.titleClassName ?? ""}`,
                children: partnerWitUSData.title
            }),
            partnerWitUSData.paragraphs.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: p.className === "default" ? "3xl:mt-6  mt-3 3xl:text-2xl  3xl:leading-10 lg:text-lg  3xl:max-w-[1040px] max-w-[740px]  font-light" : p.className,
                    children: p.text
                }, index)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mt-9 mt-12 w-fit ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: partnerWitUSData.buttonText
                })
            })
        ]
    });
}


/***/ }),

/***/ 96119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResolvedForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);



const FormNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(47341)]).then(__webpack_require__.bind(__webpack_require__, 47341)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47341)
            ]
    }
});
const FormOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(75108)]).then(__webpack_require__.bind(__webpack_require__, 75108)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75108)
            ]
    }
});
function ResolvedForm(props) {
    const { loadOneToOneForm , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // The new form is the default for every domain. Keep the legacy form
    // available as an explicit per-domain escape hatch while one-to-one flows,
    // which are only implemented by the new form, always stay on FormNew.
    const useOldForm = !loadOneToOneForm && domain?.config?.forceOldForm === true;
    return useOldForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormOld, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormNew, {
        ...props
    });
}


/***/ }),

/***/ 646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__eUAiv","innerContainerStyle":"style_innerContainerStyle__yZ9xz","main-banner":"style_main-banner__S_Gij","form":"style_form__5mIpZ","steps-inner":"style_steps-inner__pUtnH","step-title":"style_step-title__gIFG2","label-as-step-title":"style_label-as-step-title__JIbZE","step-description":"style_step-description__8iB1I","form-button":"style_form-button__sbqUN","step-block":"style_step-block__bKD0E","form-field":"style_form-field__dwswP","field-label":"style_field-label___40Vv","radio-field":"style_radio-field__7fYS3","input-field":"style_input-field__kzHPz","checkbox-field":"style_checkbox-field__K1lYp","multiSelect-field":"style_multiSelect-field__0uXIy","select-field":"style_select-field__ueFXg","text-area-field":"style_text-area-field__qKWgA","tcpa":"style_tcpa__EM_p_","back-button":"style_back-button__mQW3H","error-style":"style_error-style__5xRC6","note-style":"style_note-style__gnmV7"};

/***/ }),

/***/ 18798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__0OekM","stepStyle":"style_stepStyle__3F5I9"};

/***/ }),

/***/ 41681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"style_imgStyle__M_t7Y"};

/***/ }),

/***/ 57772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"style_btnStyle___YUoh"};

/***/ }),

/***/ 12658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__n_Qd3"};

/***/ })

}]);